import { Envelope, Plus } from "@phosphor-icons/react";
import type { CoverLetterDto } from "@reactive-resume/dto";

import { useDialog } from "@/client/stores/dialog";

import { BaseListItem } from "./base-item";

export const CreateCoverLetterListItem = () => {
  const { open } = useDialog<CoverLetterDto>("cover-letter");

  return (
    <BaseListItem
      start={<Envelope size={18} />}
      title={<span>Create a new cover letter</span>}
      description="Start building from scratch"
      onClick={() => {
        open("create");
      }}
    />
  );
};
